import React, { useState, useEffect } from 'react';
import { useParams, useOutletContext, useLocation, useNavigate } from 'react-router-dom';
import './PropertyInfo.css'; // Add CSS file for styling
import axios from 'axios';
import DateTimeDisplay from './DateTimeDisplay';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_PROXY_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const PropertyInfo = ({ dataProperty, dataTax, proxyUrl }) => {

  const { customerId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { dataClient } = useOutletContext(); // Access dataClient
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [headerLoading, setHeaderLoading] = useState(true);

  if (!dataProperty) return <div>Loading ...</div>;

  const property = dataProperty;
  const tax = dataTax;
  const client = property.client;
  const legal = property.propertyLegal;

  return (
    <div>
      <div className="content clearfix">
        <div className="row no-border">
          <div className="threeColumn borderRB">
            <ul>
              <DateTimeDisplay />
            </ul>
          </div>
          <div className="threeColumn borderB">
            <ul>
              <li><span className="lableText heading center">{client.addressInfo.address1}</span></li>
              <li><span className="lableText center">{client.addressInfo.address2}</span></li>
              <li><span className="lableText center">{client.addressInfo.address3}</span></li>
            </ul>
          </div>
          <div className="threeColumn borderLB">
            <ul>
              <li>Tax ID: {property.propertyTaxID}</li>
              <li>Type: {property.propertyOwnerPropType}</li>
            </ul>
          </div>
        </div>
        <div className="row no-border">
          <div id="detailHeader">
            <ul id="detailTaxID">
              <li className="detailLabel taxid">Pay Taxes for Tax Id: {property.propertyTaxID}</li>
            </ul>
            <ul id="detailName">
              <li className="detailLabel">Name</li>
              <li className="detailName">{property.propertyOwnerName1} {property.propertyOwnerName2}<br />{property.propertyOwnerAddress1}<br />{property.propertyOwnerCity} {property.propertyOwnerState} {property.propertyOwnerZip}<br /></li>
            </ul>
            <ul id="detailLegal">
              <li className="detailLabel legal">Property Tax Query TW Range SC Description</li>
              <li className="detailLegal legal">
                <div
                  className="legalScroll">
                  Township/Range/Section: {legal.legalPropertyTown}/{legal.legalPropertyRange}/{legal.legalPropertySection}
                  {"\n"}GEO: {legal.legalPropertyGeo}
                  {"\n"}{legal.legalPropertyLine}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div style={{ clear: 'both' }}></div>
    </div>
  );
};

export default PropertyInfo;
